var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5228 63.077C24.2478 63.0724 17.1979 60.5531 11.5676 55.946C5.93718 51.3389 2.07244 44.9272 0.628008 37.7969C-0.816422 30.6667 0.248267 23.2564 3.64171 16.8212C7.03516 10.3861 12.5487 5.32176 19.2484 2.48618C26.9547 -0.769191 35.6385 -0.829924 43.3896 2.31734C51.1406 5.4646 57.324 11.5621 60.5793 19.2683C63.8347 26.9746 63.8955 35.6584 60.7482 43.4095C57.6009 51.1605 51.5035 57.3439 43.7972 60.5992C39.9141 62.2426 35.7393 63.0853 31.5228 63.077Z",
    fill: "url(#paint0_linear_240_3064)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6445 15.795C46.7717 13.8812 42.8347 13.5297 41.0086 15.795C37.868 19.694 34.7269 23.5929 31.5852 27.4918C30.0889 29.348 28.5929 31.2044 27.0972 33.0611C26.567 33.7199 25.9347 34.7086 25.2469 35.6265L24.8447 35.2106L21.799 32.0804C16.9433 27.0928 9.31144 34.7311 14.1631 39.7163C16.6674 42.2906 19.2264 45.8889 22.6228 47.2468C26.3466 48.7359 29.6497 46.9435 32.0446 44.0387C37.6532 37.233 43.1147 30.2986 48.6477 23.4309C50.4875 21.1439 50.8382 18.0379 48.6445 15.795Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_3064",
    x1: 11.7059,
    y1: 6.6975,
    x2: 50.0816,
    y2: 54.8104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18A308"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.63b915a4584522831a1d241336060b21.svg";
export { ForwardRef as ReactComponent };